import { render, staticRenderFns } from "./ResourceMain.vue?vue&type=template&id=620e360a&"
import script from "./ResourceMain.vue?vue&type=script&lang=js&"
export * from "./ResourceMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports